<cm-routed-dialog [dialogSize]="dialogSizes.Large" [dialogScroll]="false" [needsConfirmationToClose]="$modified()" closeRoute="/templates">
    <ng-container cm-overlay-content>
        <div class="cm-main-card">
            <div class="cm-column">
                <div class="cm-row">
                    <div class="cm-caption">General</div>
                    <div class="cm-general-controls">
                        <input
                            name="templateId"
                            type="text"
                            placeholder="Enter template uuid..."
                            [ngModel]="$templateId()"
                            (ngModelChange)="setTemplateId($event)"
                            (keyup.enter)="load()"
                        />
                        <select name="templateEntry" [ngModel]="$selectedEntry()" (ngModelChange)="onEntrySelected($event)">
                            <option [ngValue]="undefined">- no code graph -</option>
                            @for (group of entryGroups; track group.customer) {
                                <optgroup [label]="group.customer">
                                    @for (entry of group.entries; track entry.label) {
                                        <option [ngValue]="entry">{{ entry.label }}</option>
                                    }
                                </optgroup>
                            }
                        </select>
                        <label>
                            Graph
                            <select name="graphSource" [ngModel]="$graphSource()" (ngModelChange)="$graphSource.set($event)">
                                <option value="prod">Prod</option>
                                <option value="code">Code</option>
                            </select>
                        </label>
                        <label>
                            Prices
                            <select name="priceSource" [ngModel]="$priceSource()" (ngModelChange)="$priceSource.set($event)">
                                <option value="db">DB</option>
                                <option value="catalog">Catalog</option>
                            </select>
                        </label>
                        <span>prod graph: {{ $prodGraph()?.state ?? "none" }}</span>
                        <span>catalog: {{ $activeCatalogLabel() }}</span>
                        <input type="text" placeholder="Enter search term..." (keyup.enter)="searchCatalog(searchTerm.value)" #searchTerm />
                        <select name="priceGraphState" [(ngModel)]="priceGraphState">
                            @for (state of $priceGraphStates(); track state) {
                                <option [value]="state">
                                    {{ state }}
                                </option>
                            }
                        </select>
                        <input type="file" (change)="initCatalogFromLocalFile($event)" hidden #fileInput />
                        <input type="file" (change)="initNewCatalogFromLocalFile($event)" hidden #fileInputNew />
                        <button mat-raised-button (click)="fileInput.click()">Load Catalog</button>
                        <button mat-raised-button (click)="fileInputNew.click()">Load New Catalog</button>
                        <button mat-raised-button (click)="verifyAndSave()">Save</button>
                        <button mat-raised-button (click)="deletePriceGraph()">Delete</button>
                        <button mat-raised-button (click)="updateCatalog()">Update Catalog</button>
                        <button mat-raised-button (click)="importCatalog()">Import Catalog</button>
                    </div>
                </div>
                <div class="cm-row cm-equal">
                    <div class="cm-caption">Search Results</div>
                    <mat-list>
                        @for (item of $searchResults(); track item.uniqueId) {
                            <mat-list-item
                                style="user-select: none"
                                [class.cm-selected]="item.uniqueId === $selectedSearchItem()?.uniqueId"
                                (click)="onSearchItemClick(item)"
                                (dblclick)="onSearchItemDoubleClick(item)"
                                >{{ item.description }}</mat-list-item
                            >
                        }
                    </mat-list>
                </div>

                <div class="cm-row cm-equal">
                    <div class="cm-caption">Api Output</div>
                    <cm-price-table
                        [items]="$currentPrices()"
                        [error]="error"
                        [currencies]="$availableCurrencies()"
                        [selectedCurrency]="$selectedCurrency() ?? $availableCurrencies()[0]"
                        [priceIncludesVat]="$priceIncludesVat()"
                        (selectedCurrencyChange)="onCurrencyChange($event)"
                    ></cm-price-table>
                </div>
            </div>
            <div class="cm-column">
                <div class="cm-row cm-equal">
                    <div class="cm-caption">Pricing Graph</div>
                    <cdk-tree [dataSource]="$dataSource()" [treeControl]="treeControl" class="cm-tree">
                        <!-- This is the tree node template for leaf nodes -->
                        <cdk-nested-tree-node
                            [class.cm-selected]="nodeSelected(node)"
                            [class.no-children]="!hasChild(0, node)"
                            *cdkTreeNodeDef="let node"
                            (click)="onTreeNodeClick(node, $event)"
                            (dragover)="onDragOver($event, node)"
                            (drop)="onDrop($event, node)"
                        >
                            <div class="cm-tree-node" [class.cm-selected]="nodeSelected(node)" (click)="onTreeNodeClick(node, $event)">
                                @if ($pricingContext(); as pricingContext) {
                                    <cm-price-node-visualizer
                                        [node]="node"
                                        [pricingContext]="pricingContext"
                                        (conditionRemoved)="updatePrice()"
                                    ></cm-price-node-visualizer>
                                }
                            </div>
                        </cdk-nested-tree-node>
                        <!-- This is the tree node template for expandable nodes -->
                        <cdk-nested-tree-node
                            [class.cm-selected]="nodeSelected(node)"
                            [class.no-children]="!hasChild(0, node)"
                            *cdkTreeNodeDef="let node; when: hasChild"
                            (dragover)="onDragOver($event, node)"
                            (drop)="onDrop($event, node)"
                        >
                            <div class="cm-tree-node" [class.cm-selected]="nodeSelected(node)" (click)="onTreeNodeClick(node, $event)">
                                <button mat-icon-button class="cm-tree-toggle-button" (click)="treeControl.toggle(node); $event.stopPropagation()">
                                    <i class="far mat-icon-rtl-mirror" [class]="treeControl.isExpanded(node) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                </button>
                                @if ($pricingContext(); as pricingContext) {
                                    <cm-price-node-visualizer
                                        [node]="node"
                                        [pricingContext]="pricingContext"
                                        (conditionRemoved)="updatePrice()"
                                    ></cm-price-node-visualizer>
                                }
                            </div>
                            <div [class.cm-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                                <ng-container cdkTreeNodeOutlet></ng-container>
                            </div>
                        </cdk-nested-tree-node>
                    </cdk-tree>
                </div>

                <div class="cm-row">
                    <div class="cm-caption">Node Settings</div>
                    <div class="cm-content">
                        <cm-node-settings [node]="$selectedTreeNode()"></cm-node-settings>
                    </div>
                </div>
            </div>
            <div class="cm-column">
                <div class="cm-caption">Configurator</div>
                <div class="cm-menu"><cm-config-menu #configuratorMenu [externalMenu]="true"></cm-config-menu></div>
                <div class="cm-configurator">
                    <cm-configurator
                        [showUi]="false"
                        [forceWebGl]="false"
                        (loadingCompleted)="loadPriceGraph()"
                        (configurationLoaded)="updateCurrentConfigurations()"
                        #configurator
                    ></cm-configurator>
                </div>
            </div>
        </div>
    </ng-container>
</cm-routed-dialog>
